function pointsToWKT(nw, ne, sw, se) {
    return "POLYGON((" + nw.lng + " " + nw.lat +","+ ne.lng + " " + ne.lat +","
        + se.lng + " " + se.lat +","+ sw.lng + " " + sw.lat + ","+ nw.lng + " " + nw.lat + "))";
}
function bboxToWKT(bbox) {
    return pointsToWKT(bbox.getNorthWest(), bbox.getNorthEast(), bbox.getSouthWest(), bbox.getSouthEast());
}

function pointToWKT(lng, lat) {
    return "POINT(" + lng + " " + lat + ")";
}

function WKTToLatLngBounds(box) {
    const points = box.slice(4,-1).split(',');
    const ptA = points[0].split(' ').reverse().map(function (item) {return parseFloat(item);});
    const ptB = points[1].split(' ').reverse().map(function (item) {return parseFloat(item);});
    return [ptA, ptB];
}

function polygonToWKT(latlngs) {
    let points = [];
    for (let index = 0; index < latlngs.length; index++) {
        points.push(latlngs[index].lng + " " + latlngs[index].lat)
    }
    points.push(latlngs[latlngs.length-1].lng + " " + latlngs[latlngs.length-1].lat); // add last point to list ?
    return "POLYGON((" + points.join(",") + "))";
}

function circleToWKT(center, radius) {
    return "'POINT(" + center.lng + " " + center.lat + ")','radius':" + radius +"'";
}

export {bboxToWKT, pointToWKT, WKTToLatLngBounds, polygonToWKT, circleToWKT};